<template>
  <div v-if="visible" class="grid overflow-hidden" :class="gridCssClass">
    <template v-for="card in record.cards">
      <slot :card="card" :breakpoint="media" :record="record"></slot>
    </template>
  </div>
</template>
<script>
import Media from '../../mixins/Media';
import { AjaxCaller } from '@ssdcode/cms-partials';
import ErrorReporter from '../../core/ErrorReporter';
export default {
  name: 'GridWrapper',
  mixins: [Media, AjaxCaller],
  props: {
    grid: {
      type: [Object, Number],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      record: {},
    };
  },
  computed: {
    visible() {
      return this.record.cards && this.record.cards.length > 0;
    },
    gridCssClass() {
      return [
        {
          'gap-6': !this.record.is_collapsed,
          'rounded-md': this.record.is_collapsed,
        },
        'grid-cols-' + this.record.columns_small,
        'md:grid-cols-' + this.record.columns_medium,
        'lg:grid-cols-' + this.record.columns_large,
        'xl:grid-cols-' + this.record.columns_xlarge,
      ];
    },
    url() {
      return '/data/grid/' + this.grid;
    },
  },
  mounted() {
    if (typeof this.grid === 'number') {
      this.makeAjaxRequest(this.success, this.failure, {}, this.url, 'post');
      return;
    }
    this.record = this.grid;
  },
  methods: {
    success(response) {
      this.stopProcessingAjaxCall();
      this.record = response.data;
    },
    failure(error) {
      this.stopProcessingAjaxCall();
      ErrorReporter.report(error);
    },
  },
};
</script>
